import * as styles from "./CardTextRadio.css";
import { ComponentPropsWithRef } from "react";
import DrawnCircle from "~/assets/svgs/DrawnCircle";
import { Check, X } from "@untitled-ui/icons-react";
import { fluid } from "~/styles/functions";
import { CardText } from "./CardText";
import clsx from "clsx";

type CardTextRadioProps = {
  selected?: boolean;
  theme?: "primary" | "positive" | "negative";
} & ComponentPropsWithRef<"div">;

export const CardTextRadio = ({
  children,
  className,
  selected = false,
  theme = "primary",
  ...props
}: CardTextRadioProps) => {
  return (
    <div className={styles.theme({ theme: theme })}>
      <div className={clsx(className, styles.card)} {...props}>
        <div className={styles.radioButton}>
          <DrawnCircle className={styles.circle({ selected: selected })} />
          <div className={styles.icons({ selected: selected })}>
            <div className={styles.icon}>
              {theme == "negative" ? (
                <X width={fluid("12.5px")} height={fluid("12.5px")} />
              ) : (
                <Check width={fluid("12.5px")} height={fluid("12.5px")} />
              )}
            </div>
            <div className={styles.icon}>
              {theme == "negative" ? (
                <X width={fluid("12.5px")} height={fluid("12.5px")} />
              ) : (
                <Check width={fluid("12.5px")} height={fluid("12.5px")} />
              )}
            </div>
          </div>
        </div>
        <CardText theme="light" width="full">
          {children}
        </CardText>
      </div>
    </div>
  );
};
